<template>

  <section id="planos" class="d-flex align-items-center planos">

    <div class="container">

      <div class="section-title" data-aos="fade-up">
        <div class="row">
          <h1 data-aos="fade-up">Planos Contabilidade Digital</h1>
          <h5 class="mb-5" data-aos="fade-up" data-aos-delay="400">Escolha o melhor plano para o seu negócio</h5>
        </div>

        <div class="row mb-5">

          <div class="col-md-4 align-items-stretch pt-4 pt-xl-0" data-aos="fade-left" data-aos-delay="300">
            <div class="box recommended" data-aos="zoom-in-left" data-aos-delay="200">
              <h2><strong>Bronze</strong></h2>
              <h4><sup>R$</sup>300<span> / mês</span></h4>
              <!--
              <div class="col-lg-12" data-aos="fade-up" data-aos-delay="150">
                100 notas/mês   Abertura Grátis*
              </div>
              <div class="col-lg-12 mb-4" data-aos="fade-up" data-aos-delay="150">
                R$ 0,75 por nota adicional
              </div>
              -->
              <div class="h6"><strong style="color: #039754;">Abertura Grátis*</strong></div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150" style="color: #009587;">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Taxa de adesão <strong>grátis</strong>
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Planejamento tributário
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Serviços contábeis
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Serviços fiscais
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Serviços societários
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> 5 notas do nosso emissor de NFs-e
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Atendimento via e-mail e telefone
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Atendimento via whatsApp
              </div>

              <div class="btn-wrap">
                <a href="https://api.whatsapp.com/send/?phone=5544999329925&amp;text=Acessei%20o%20site%20do%20Sigame%20e%20gostaria%20de%20consultar%20plano%20bronze." class="btn-buy">Assinar</a>
              </div>
            </div>
          </div>

          <div class="col-md-4 align-items-stretch pt-4 pt-xl-0" data-aos="fade-left" data-aos-delay="300">
            <div class="box recommended" data-aos="zoom-in-left" data-aos-delay="200">
              <h2><strong>Prata</strong></h2>
              <h4><sup>R$</sup>400<span> / mês</span></h4>

              <div class="h6"><strong style="color: #039754;">Abertura Grátis*</strong></div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150" style="color: #009587;">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Taxa de adesão <strong>grátis</strong>
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Planejamento tributário
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Serviços contábeis
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Serviços fiscais
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Serviços societários
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> 20 notas do nosso emissor de NFs-e
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Folha de pagamento
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Atendimento via e-mail e telefone
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Atendimento via whatsApp
              </div>

              <div class="btn-wrap">
                <a href="https://api.whatsapp.com/send/?phone=5544999329925&amp;text=Acessei%20o%20site%20do%20Sigame%20e%20gostaria%20de%20consultar%20plano%20prata." class="btn-buy">Assinar</a>
              </div>
            </div>
          </div>

          <div class="col-md-4 align-items-stretch pt-4 pt-xl-0" data-aos="fade-left" data-aos-delay="300">
            <div class="box recommended" data-aos="zoom-in-left" data-aos-delay="200">
              <h2><strong>Ouro</strong></h2>
              <h4><sup>R$</sup>600<span> / mês</span></h4>

              <div class="h6"><strong style="color: #039754;">Abertura Grátis*</strong></div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150" style="color: #009587;">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Taxa de adesão <strong>grátis</strong>
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Planejamento tributário
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Serviços contábeis
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Serviços fiscais
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Serviços societários
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> 20 notas do nosso emissor de NFs-e
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Folha de pagamento
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Imposto de renda
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Orientação jurídica
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Atendimento via e-mail e telefone
              </div>

              <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
                <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> Atendimento via whatsApp
              </div>

              <div class="btn-wrap">
                <a href="https://api.whatsapp.com/send/?phone=5544999329925&amp;text=Acessei%20o%20site%20do%20Sigame%20e%20gostaria%20de%20consultar%20plano%20ouro." class="btn-buy">Assinar</a>
              </div>
            </div>

          </div>

        </div>

        <div class="row" style="padding-bottom: 60px;">
          <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
            <strong style="font-size: 18px;">Adicional:</strong>
          </div>

          <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
            <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> R$ 50,00 por funcionário
          </div>

          <div class="col-lg-12 opcoes" data-aos="fade-up" data-aos-delay="150">
            <i class="bi bi-check-lg" style="font-size: 1.2rem; color: #009587;"></i> R$ 50,00 adicional a cada R$ 100.000,00 de faturamento mensal
          </div>

          <div class="padding: 400px;">
            <br>
            <br>
            <br>
          </div>

          <h1 data-aos="fade-up">Seu negócio precisa de mais opções contábeis?</h1>
          <h5 class="mb-3" data-aos="fade-up" data-aos-delay="400">Fale com a gente e solicite um plano personalizado para você.</h5>

          <div class="box-button" data-aos="zoom-in-left" data-aos-delay="200">
            <div >
                <div >
                    <a class="btn-plano" style="text-decoration: none; padding: 15px 40px 12px 40px"
                      href="https://api.whatsapp.com/send/?phone=5544999329925&amp;text=Acessei%20o%20site%20do%20Sigame%20e%20gostaria%20de%20consultar%20plano%20personalizado.">
                      Consulte
                    </a>
                </div>
              </div>
          </div>

        </div>

      </div>

    </div>

</section>

</template>

<script>
export default {
  name: 'PlanoComp'
}
</script>

<style scoped lang="scss">
.planos {
  background-color: $plano-bg-color;
  padding: 5vh 1vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: -40px;
}

.planos .box {
  padding: 20px;
  background: $plano-box-bg-color;
  text-align: center;
  border-radius: 8px;
  border: 2px solid $bg-color-2;
  box-shadow: $plano-icon-box-box-shadow;
  transition: box-shadow 0.3s ease;
  border-radius: 8px; /* 40px; */
  z-index: 1;
}

.planos .box h3 {
  font-weight: 400;
  padding: 15px;
  margin-top: 15px;
  font-size: 18px;
  font-weight: 600;
  color: $color-base;
}

.planos .box h4 {
  font-size: 42px;
  color: $a-color;
  font-weight: 500;
  margin-bottom: 20px;
}

.planos .opcoes {
  margin: 0px 0px 0px 0px;
  font-size: 14px;
  text-align: left;
}

.planos .box .opcoes i {
  text-align: left;
}

.planos .box h4 sup {
  font-size: 20px;
  top: -15px;
  left: -3px;
}

.planos .box h4 span {
  color: $color-base;
  font-size: 16px;
  font-weight: 300;
}

.planos .h6 {
  font-size: 24px;
  margin-bottom: 20px;
}

.planos .box ul {
  padding: 0;
  list-style: none;
  color: $color-base;
  text-align: center;
  line-height: 20px;
  font-size: 14px;
}

.planos .box ul li {
  padding-bottom: 16px;
}

.planos .box ul i {
  color: $a-color;
  font-size: 18px;
  padding-right: 4px;
}

.planos .box .btn-wrap {
  padding: 15px;
  text-align: center;
}

.planos .box .btn-buy {
  display: inline-block;
  padding: 15px 40px 12px 40px;
  border-radius: 50px;
  border: 2px solid $a-color;
  color: $a-color;
  font-size: 14px;
  transition: 0.3s;
  width: 180px;
  text-decoration: none;
}

.planos .box .btn-buy:hover {
  border: 2px solid $a-color-hover;
  background: $a-color-hover;
  color: $bg-base;
}

.planos .box-button {
  margin-top: 10px;
  padding: 10px;
  text-align: center;
}

.planos .box-button .btn-contato a {
  display: inline-block;
  padding: 10px 40px 12px 40px;
  border-radius: 50px;
  border: 2px solid $a-color;
  color: $a-color;
  font-size: 14px;
  transition: 0.3s;
  width: 200px;
}

.planos .box-button .btn-contato a:hover {
  color: $bg-base;
  border: 2px solid $a-color-hover;
  background: $a-color-hover;
}

.planos .btn-plano {
  display: inline-block;
  padding: 15px 40px 12px 40px;
  border-radius: 50px;
  border: 2px solid $a-color;
  color: #fff;
  background-color: $a-color;
  font-size: 14px;
  transition: 0.3s;
  width: 180px;
  text-decoration: none;
}

.planos .btn-plano:hover {
  border: 2px solid $a-color-hover;
  background-color: $a-color-hover;
}

.planos .recommended {
  border-color: $a-color;
}

.planos .recommended .btn-buy {
  background: $a-color;
  color: $bg-base;
}

</style>
